// 2_components/products_block_reviews_number.js
// Appends the review count (e.g. "12x") next to the star rating on each product
// card in product blocks, re-running on Shoptet/favorites/Raventic content loads.

export function init() {
	productsBlockReviewsNumber();

	document.addEventListener("ShoptetDOMContentLoaded", function () {
		productsBlockReviewsNumber();
	});

	document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
		productsBlockReviewsNumber();
	});

	document.addEventListener("dkLabFavouriteProductsLoaded", function () {
		productsBlockReviewsNumber();
	});

	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", function () {
		productsBlockReviewsNumber();
	});
}

function productsBlockReviewsNumber() {
	const allProductsInProductsBlock = document.querySelectorAll(".products-block .product");
	if (!allProductsInProductsBlock || allProductsInProductsBlock.length === 0) {
		return; // No products found
	}
	allProductsInProductsBlock.forEach((product) => {
		if (product.classList.contains("reviews-added")) {
			return; // Skip if already processed
		}
		product.classList.add("reviews-added");

		const starWrapper = product.querySelector(".stars-wrapper");
		if (starWrapper) {
			const reviewsNumber = starWrapper.getAttribute("data-micro-rating-count");
			if (reviewsNumber) {
				const reviewsNumberSpan = document.createElement("span");
				reviewsNumberSpan.className = "reviews-number";
				reviewsNumberSpan.innerHTML = reviewsNumber + "x";
				starWrapper.appendChild(reviewsNumberSpan);
			}
		}
	});
}
